import { create } from "zustand";

import { useInvoices } from "../../useInvoices";

export let useOtherChargesBlock = create((set, get) => ({
  // accountHandler: (value, rowIndex) => {
  //   const currentState = useInvoices.getState();
  //   //const updatedCodes = currentState.form.invoice_codes;
  //   const updatedCharges = currentState.form.invoice_codes.map((row) => [...row]);
  //   updatedCharges[rowIndex][0] = value;

  //   useInvoices.setState({
  //     form: {
  //       ...currentState.form,
  //       invoice_other_charges: updatedCharges,
  //     },
  //   });
  // },

  itemHandler: (value, rowIndex, pos) => {
    const currentState = useInvoices.getState();
    const updatedCharges = currentState.form.invoice_other_charges.map(
      (row) => [...row]
    );
    updatedCharges[rowIndex][pos] = value;

    useInvoices.setState({
      form: {
        ...currentState.form,
        invoice_other_charges: updatedCharges,
      },
    });
  },
  addOther: () => {
    const currentState = useInvoices.getState();
    useInvoices.setState((state) => ({
      form: {
        ...state.form,
        invoice_other_charges: [...state.form.invoice_other_charges, ["", ""]],
      },
    }));
  },

  deleteOther: (rowIndex) => {
    useInvoices.setState((state) => {
      const updatedCharges = state.form.invoice_other_charges.filter(
        (_, index) => index !== rowIndex
      );
      return {
        form: {
          ...state.form,
          invoice_other_charges: updatedCharges,
        },
      };
    });
  },
}));
